import React, {Component} from 'react';

class Loader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // menu:[],
        }
    }

    render() {
        return (
            <div className="loading_box">
                <img className="loadinLogo" src="/assets/img/logo.png" alt="NaturewayMart"/>
                <img className="loadinIcon" src="/assets/img/loading.gif" alt="NaturewayMart"/>
            </div>
        );
    }
}

export default Loader;